export const MenuList = [
  
  {
    title: "Users",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#87C55F" }} className="flaticon-381-user-2"></i>
    ),
    to: "/users",
  },
 {
    title: "Mentor",
    classsChange: "mm-collapse",
    iconStyle: <i style={{color:"#87C55F"}} className="flaticon-381-user-5"></i>,
    to: "/mentor",
  },
   
  {
    title: "Category",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#87C55F" }} className="flaticon-381-notebook"></i>
    ),
    to: "/category",
  },
 {
    title: "Contact Us",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#87C55F" }} className="flaticon-381-notebook-4"></i>
    ),
    to: "/contact-us",
  },

  {
    title: "Subscriptions",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#87C55F" }} className="flaticon-381-price-tag"></i>
    ),
    to: "/subscriptions",
  },

  {
    title: "Earnings",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#87C55F" }} className="flaticon-381-controls-3"></i>
    ),
    to: "/earnings",
  },
  
 {
    title: "Legal",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#87C55F" }} className="flaticon-381-layer-1"></i>
    ),
    
    content: [
      {
        title: "Terms & Condtion",
        to: "/terms-condition",
      },
      {
        title: "Privacy Policy",
        to: "/privacy-policy",
      },
      {
        title: "About Us",
        to: "/about",
      },
    ],
  },

 
];
